<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select
                        v-model="searchData.SId"
                        :loading="loading"
                        class="search-item"
                        size="small"
                        filterable
                        clearable
                        remote
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <div class="search-name">库存数</div>
                    <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="> < =">
                        <el-option key=">=" label=">=" value=">="></el-option>
                        <el-option key=">" label=">" value=">"></el-option>
                        <el-option key="<=" label="<=" value="<="></el-option>
                        <el-option key="<" label="<" value="<"></el-option>
                        <el-option key="=" label="=" value="="></el-option>
                        <el-option key="!=" label="!=" value="!="></el-option>
                        <el-option key="between" label="区间" value="between"></el-option>
                    </el-select>
                    <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent1"></el-input>
                    <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">品牌</div>
                    <div class="search-item goods-categories">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配分类</div>
                    <div class="search-item goods-categories">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            remote
                            :remote-method="searchGoodsType"
                            v-select-scroll-more="searchGoodsTypeLoad"
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>现有库存总数</p>
                            <p>{{ statData.countTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>积压成本总额</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.costTotal }}</p>
                        </div>
                        <!-- <div class="data-item">
                            <p>标签成本总额</p>
                            <p style="color: green; font-size: 16px">
                                <el-button v-if="loadTotalCost" icon="el-icon-loading" type="text"></el-button>
                                {{ !loadTotalCost ? labelTotalCost : '' }}
                            </p>
                        </div> -->
                        <div class="data-item">
                            <p>待入总数</p>
                            <p>
                                {{ statData.waitInTotal }}
                            </p>
                        </div>
                        <div class="data-item">
                            <p>待出总数</p>
                            <p>{{ statData.waitOutTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>留余总数</p>
                            <p style="color: green; font-size: 16px">
                                {{ statData.surplusTotal }}
                            </p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SaleTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="Brand" label="品牌"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="APCate" label="分类"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable="custom" prop="InventoryAmount" label="现有库存"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable="custom" prop="CostPrice" label="成本价"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="110" prop="TotalCost" label="总成本"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" prop="TotalStayOut" label="待出仓"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" prop="TotalStayIn" label="待入仓"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" prop="TotalSurplus" label="留余"></el-table-column>
                    <el-table-column  label="其他统计" width="85px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img class="image-cus" src="@/assets/images/customer.png" title="客户销售数据" @click="showSaleStat(scope.row)" />
                                <img class="image-sup" src="@/assets/images/supplier.png" title="供应商采购数据" @click="showPurchaseStat(scope.row)" />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :title="SaleDialogTitle" :visible.sync="showSaleStatDialog" :append-to-body="true" width="1100px">
                <div v-if="showSaleStatDialog">
                    <saleStat @closeDialog="closeSaleStatDialog" :APId="this.APId" :ShowCus="true"></saleStat>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :title="PurchaseDialogTitle" :visible.sync="showPurchaseStatDialog" :append-to-body="true" width="1100px">
                <div v-if="showPurchaseStatDialog">
                    <purchaseStat @closeDialog="closePurchaseStatDialog" :APId="this.APId"></purchaseStat>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import saleStat from '@/components/business/revenue/apSaleStat';
import purchaseStat from '@/components/business/revenue/apPurchaseStat';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'inventoryStat',
    components: {
        breadcrumb,
        saleStat,
        purchaseStat
    },
    data() {
        return {
            showPurchaseStatDialog: false,
            showSaleStatDialog: false,
            timeVisible: false,
            loading: false,
            loadTotalCost: true,
            brand: [],
            typeList: [],
            SaleDialogTitle: '',
            PurchaseDialogTitle: '',
            searchData: {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                Invent1: 0,
                Invent2: 0,
                page: 1,
                limit: 15
            },
            statData: {
                countTotal: 0,
                costTotal: 0,
                waitInTotal: 0,
                waitOutTotal: 0,
                surplusTotal: 0
            },
            labelTotalCost: 0,
            dialogVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            WarehouseList: [],
            // 用于汽配分类列表，分页搜索
            typeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        // this.getWarehouse();
    },
    watch: {
        dialogVisible(value) {
            if (!value) {
                this.choosedGood = {};
            }
        }
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.searchData.page = 1;
            this.handleSearch();
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        // searchGoodsType() {
        //     this.$util
        //         .getEntpApCategoryList()
        //         .then(data => {
        //             if (!data) return;
        //             this.typeList = data;
        //         })
        //         .catch(() => {});
        // },
        searchGoodsType(key) {
            if (![undefined].includes(key)) {
                this.typeForm.Page = 1;
                this.typeForm.stopLoad = false;
                this.typeForm.key = key;
                this.typeList = [];
            }
            if (this.typeForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.typeForm.key, this.typeForm.Page, this.typeForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.typeForm.stopLoad = data.length < this.typeForm.Limit;
                    this.typeList = [...this.typeList, ...data];

                })
                .catch(() => {
                });
        },
        // 客户名称列表，加载更多
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                Invent1: 0,
                Invent2: 0,
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 关闭弹窗
        closeDialog(edit) {
            this.dialogVisible = false;
            this.choosedGood = {};
            if (edit) {
                this.getTableData();
            }
        },
        // 获取数据
        getTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            }
            // this.loadTotalCost = true;
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/InventoryStatistics_V2',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    // for (let i = 0; i < data.DataList.length; i++) {
                        // data.DataList[i].LoadAcTotalCost = true;
                        // data.DataList[i].AcTotalCost = 0;
                    // }
                    this.tableData = data.DataList;
                    this.statData = {
                        countTotal: data.CountTotal,
                        costTotal: data.CostTotal,
                        waitInTotal: data.WaitInTotal,
                        waitOutTotal: data.WaitOutTotal,
                        surplusTotal: data.SurplusTotal
                    };
                    this.tableDataLength = res.count;
                    // this.getLabelCostData();
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.Id;
                this.showSaleStatDialog = true;
            }
        },
        closeSaleStatDialog() {
            this.showSaleStatDialog = false;
        },
        showPurchaseStat(row) {
            if (row) {
                this.PurchaseDialogTitle = '采购数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.Id;
                this.showPurchaseStatDialog = true;
            }
        },
        closePurchaseStatDialog() {
            this.showPurchaseStatDialog = false;
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.WarehouseList.length <= 1) that.getWarehouse();
            }
        },
        getLabelCostData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/GetGoodsLabelCostData',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.labelTotalCost = data;
                    this.loadTotalCost = false;
                })
                .catch(() => {});
        },
        showAcData() {}
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }

        .el-button {
            padding: 0;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
    .image-cus {
        width: 22px;
        height: 22px;
    }
}
</style>